import React from 'react';

/**
 * Field chrome shared by every step of the wizard.
 *
 * The same three declarations are copy-pasted into `ZoneFormModal`,
 * `AddressFields` and `ManualOrderForm`; collected here so the six files of
 * this form read from one place instead of adding six more copies.
 */
export const inputClass =
  'w-full bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl px-4 py-2.5 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors disabled:opacity-60 disabled:cursor-not-allowed';

export const labelClass = 'block text-sm font-semibold text-ninja-dark dark:text-white mb-1.5';

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string} [props.error]
 * @param {string} [props.hint] - Shown only while there is no error to show.
 */
export const Field = ({ label, error, hint, children }) => (
  <div>
    <label className={labelClass}>{label}</label>
    {children}
    {error ? (
      <p className="text-danger text-xs mt-1">{error}</p>
    ) : (
      hint && <p className="text-text-muted text-xs mt-1">{hint}</p>
    )}
  </div>
);
